<template>
  <!--
    Student offer: intentionally commented out across this file — toggle + discount banner,
    verification modal, and student strikethrough “original” prices (mobile + desktop).
    Script still uses isStudent ref (always false) for product lookups.
  -->
  <div class="w-full mx-auto py-4 lg:py-6 relative">
    <div id="pricing" class="mx-auto text-center mb-8 lg:mb-12">
      <!-- One-time payment availability (info only; credit purchase UI stays hidden) -->
      <div
        class="mb-4 md:mb-6 mx-auto max-w-xl bg-blue-50 border border-slate-200 p-3 md:p-4 rounded-lg"
        :class="{ 'space-x-reverse': locale === 'ar' }"
      >
        <div
          class="flex items-start justify-center gap-2"
          :class="[
            locale === 'ar' ? 'flex-row-reverse text-right' : 'flex-row text-left',
          ]"
        >
          <svg
            class="flex-shrink-0 w-5 h-5 text-green-500 mt-0.5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            />
          </svg>
          <div class="flex flex-col gap-1">
            <p class="text-sm md:text-base font-semibold text-[#061B44]">
              {{ $t("pricing-one-time-headline") }}
            </p>
            <p class="text-xs md:text-sm font-medium text-blue-700">
              {{ $t("pricing-one-time-description") }}
            </p>
          </div>
        </div>
      </div>
      <div
        class="flex flex-row w-full rounded-full bg-blue-600 text-white py-2 px-3 justify-center items-center"
      >
        <span class="font-bold text-xs md:text-sm px-1">{{
          $t("monthly-subscriptions")
        }}</span>
        <span class="font-normal text-xs md:text-sm">{{
          $t("cost-effectiveness-for-regular-use")
        }}</span>
      </div>
      <!-- Student offer: I am a student toggle + students discount banner (commented) -->
      <!--
      <div
        v-if="isMonthlyTab"
        className="mt-8 flex items-center justify-center gap-2"
      >
        <label class="inline-flex items-center cursor-pointer">
          <input type="checkbox" v-model="isStudent" class="sr-only peer" />
          <div
            class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-subDark"
          ></div>
          <span class="ms-3 text-sm md:text-base font-medium text-slate-800">{{
            $t("i-am-a-student")
          }}</span>
        </label>
      </div>
      <div
        v-if="isMonthlyTab"
        class="mt-6 bg-blue-50 text-blue-700 p-1 md:p-3 rounded-lg inline-block"
      >
        <p class="text-xs md:text-base font-medium">
          {{ $t("students-receive-a-discount-on-all") }}
        </p>
        <span
          @click="showStudentVerification = true"
          class="text-xs md:text-base font-medium cursor-pointer text-orange-700"
          >{{ $t("how-to-do-that") }}</span
        >
      </div>
      -->
    </div>
    <div
      v-if="isMonthlyTab"
      class="grid lg:hidden grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-6"
    >
      <!-- Pricing Card -->
      <div
        :class="{
          'border-green-500 border-[3px]':
            userStore.subscriptionType === 'FREE',
        }"
        class="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8"
      >
        <h3 class="mb-4 text-2xl font-semibold">
          {{ packages[0].name.toUpperCase() }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ packages[0].subtitle }}
        </p>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ packages[0].description }}
        </p>
        <div class="flex justify-center items-center mt-4 h-20">
          <span class="mr-2 text-5xl font-extrabold">{{
            packages[0].price
          }}</span>
          <span class="text-gray-500">{{ packages[0].period }}</span>
        </div>
        <ul role="list" class="mb-8 space-y-4 text-left h-72">
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("unlimited-youtube-transcription-for-videos-with-cc")
            }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("unlimited-usage-of-srt-text-editing-and-exporting")
            }}</span>
          </li>
        </ul>
        <div
          v-if="userStore.subscriptionType === 'FREE'"
          class="rounded-lg bg-green-100 text-green-700 text-sm px-5 py-2.5 font-semibold uppercase border-[2px] border-green-700"
        >
          {{ $t("active") }}
        </div>
        <button
          v-else-if="!authStore.token"
          @click="handleClickOffer('FREE')"
          class="text-slate-900 bg-white border font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {{ $t("get-started") }}
        </button>
      </div>

      <div
        :class="{
          'border-green-500 border-[3px]':
            userStore.subscriptionType === 'STARTER',
        }"
        class="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8"
      >
        <h3 class="mb-4 text-2xl font-semibold">
          {{ packages[1].name.toUpperCase() }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ packages[1].description }}
        </p>
        <div class="flex justify-center items-center mt-4 h-20">
          <span class="mr-2 text-5xl font-extrabold">{{
            packages[1].price
          }}</span>
          <span class="text-gray-500">{{ packages[1].period }}</span>
          <!-- Student discount strikethrough (hidden with student option)
          <span
            v-if="
              isStudent &&
              packages[1].code !== 'FREE' &&
              packages[1].code !== 'ENTREPRISE'
            "
            :class="{ 'text-white': packages[1].popular }"
            class="text-xl text-gray-700 ml-1 line-through"
            >${{ getStandartProductPrice(packages[1].code) }}</span
          >
          -->
        </div>
        <ul role="list" class="mb-8 space-y-4 text-left h-72">
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("30-min-of-audio-transcription") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("30k-chars-translation-between-100-languages") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("30k-chars-from-text-to-realistic-voice-over-using-ai")
            }}</span>
          </li>
        </ul>
        <div
          v-if="userStore.subscriptionType === 'STARTER'"
          class="rounded-lg bg-green-300 text-green-900 text-sm px-5 py-2.5 font-semibold uppercase"
        >
          {{ $t("activated") }}
        </div>
        <button
          v-else
          @click="handleClickOffer('STARTER')"
          class="text-slate-900 bg-white border font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {{ $t("get-started") }}
        </button>
      </div>

      <div
        :class="{
          'border-green-500 border-[3px]': userStore.subscriptionType === 'PRO',
        }"
        class="relative flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8"
      >
        <div
          class="p-1 top-0 left-1/2 transform -translate-x-1/2 items-center justify-center flex flex-col absolute bg-orange-400 rounded-b-lg text-white font-semibold px-4"
        >
          {{ $t("most-popular") }}
        </div>
        <h3 class="mb-4 text-2xl font-semibold">
          {{ packages[2].name.toUpperCase() }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ packages[2].description }}
        </p>
        <div class="flex justify-center items-center mt-4 h-20">
          <span class="mr-2 text-5xl font-extrabold">{{
            packages[2].price
          }}</span>
          <span class="text-gray-500">{{ packages[2].period }}</span>
          <!-- Student discount strikethrough (hidden with student option)
          <span
            v-if="
              isStudent &&
              packages[2].code !== 'FREE' &&
              packages[2].code !== 'ENTREPRISE'
            "
            class="text-xl text-gray-700 ml-1 line-through"
            >${{ getStandartProductPrice(packages[2].code) }}</span
          >
          -->
        </div>
        <ul role="list" class="mb-8 space-y-4 text-left h-72">
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("90-min-of-audio-transcription") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("100k-chars-translation-between-100-languages")
            }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("100k-chars-from-text-to-realistic-voice-over-using-ai")
            }}</span>
          </li>
        </ul>
        <div
          v-if="userStore.subscriptionType === 'PRO'"
          class="rounded-lg bg-green-300 text-green-900 text-sm px-5 py-2.5 font-semibold uppercase"
        >
          {{ $t("activated") }}
        </div>
        <button
          v-else
          @click="handleClickOffer('PRO')"
          class="text-slate-900 bg-white border font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {{ $t("get-started") }}
        </button>
      </div>
      <div
        class="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8"
        :class="{
          'border-green-500 border-[3px]':
            userStore.subscriptionType === 'PREMIUM',
        }"
      >
        <h3 class="mb-4 text-2xl font-semibold">
          {{ packages[3].name.toUpperCase() }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ packages[3].description }}
        </p>
        <div class="flex justify-center items-center mt-4 h-20">
          <span class="mr-2 text-5xl font-extrabold">{{
            packages[3].price
          }}</span>
          <span class="text-gray-500">{{ packages[3].period }}</span>
          <!-- Student discount strikethrough (hidden with student option)
          <span
            v-if="
              isStudent &&
              packages[3].code !== 'FREE' &&
              packages[3].code !== 'ENTREPRISE'
            "
            :class="{ 'text-white': packages[3].popular }"
            class="text-xl text-gray-700 ml-1 line-through"
            >${{ getStandartProductPrice(packages[3].code) }}</span
          >
          -->
        </div>
        <ul role="list" class="mb-8 space-y-4 text-left h-72">
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("180-min-of-audio-transcription") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("200k-chars-translation-between-100-languages")
            }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{
              $t("200k-chars-from-text-to-realistic-voice-over-using-ai")
            }}</span>
          </li>
          <!-- <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("premium-customer-support") }}</span>
          </li> -->
        </ul>
        <div
          v-if="userStore.subscriptionType === 'PREMIUM'"
          class="rounded-lg bg-green-300 text-green-900 text-sm px-5 py-2.5 font-semibold uppercase"
        >
          {{ $t("activated") }}
        </div>
        <button
          v-else
          @click="handleClickOffer('PREMIUM')"
          class="text-slate-900 bg-white border font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {{ $t("get-started") }}
        </button>
      </div>
      <div
        :class="{
          'border-green-500 border-[3px]':
            userStore.subscriptionType === 'ENTREPRISE',
        }"
        class="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow xl:p-8"
      >
        <h3 class="mb-4 text-2xl font-semibold">
          {{ $t("enterprise-package") }}
        </h3>
        <p class="font-light text-gray-500 sm:text-lg h-10">
          {{ $t("custom-solutions-for-larger-organizations") }}
        </p>
        <div class="h-20 flex flex-col items-center justify-center mt-4">
          <span class="text-gray-800 font-semibold">{{
            $t("contact-us-for-pricing")
          }}</span>
        </div>
        <ul role="list" class="mb-8 space-y-4 text-left h-72">
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("pay-as-you-go-pricing-model") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("flexible-seat-options-based-on-your-needs") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("custom-consumption-estimates-based-on-usage") }}</span>
          </li>
          <li class="flex items-center space-x-3">
            <svg
              class="flex-shrink-0 w-5 h-5 text-green-500"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>{{ $t("dedicated-account-management") }}</span>
          </li>
        </ul>
        <div
          v-if="userStore.subscriptionType === 'ENTREPRISE'"
          class="rounded-lg bg-green-300 text-green-900 text-sm px-5 py-2.5 font-semibold uppercase"
        >
          {{ $t("activated") }}
        </div>
        <router-link
          to="#contact"
          class="text-slate-900 border bg-white scroll-smooth font-medium rounded-lg text-sm px-5 py-2.5 text-center"
        >
          {{ $t("contact-us") }}
        </router-link>
      </div>
    </div>
    <div v-if="isMonthlyTab" class="hidden lg:flex mx-auto">
      <table class="w-full border-collapse mx-auto">
        <thead>
          <tr>
            <th class="p-2 text-left"></th>
            <th
              v-for="(pkg, index) in packages"
              :key="pkg.code"
              class="p-2 text-left relative"
            >
              <div
                :class="`transform h-60 py-14 w-[140px] xl:w-[160px] transition-all duration-300 hover:scale-105 rounded-t-xl ${
                  pkg.popular ? 'bg-[#061B44] shadow-md' : 'bg-white'
                } p-2`"
              >
                <div
                  v-if="pkg.popular"
                  class="top-4 absolute text-xs font-bold flex flex-row items-end text-nowrap"
                >
                  <img src="../assets/icons/crown.svg" class="w-6 xl:w-8" />
                  <div class="flex flex-col justify-center">
                    <p class="text-[#EFA83C] text-xs font-medium">
                      {{ $t("most-popular") }}
                    </p>
                    <p class="text-white text-xs font-medium">
                      {{ $t("professionals-choice") }}
                    </p>
                  </div>
                </div>
                <h3
                  :class="{ 'text-white': pkg.popular }"
                  class="text-sm font-bold mb-2"
                >
                  {{ getFirstCapitalizedName(pkg.name) }}
                </h3>
                <div class="flex items-baseline mb-2">
                  <span
                    :class="{ 'text-white': pkg.popular }"
                    class="text-3xl font-extrabold"
                    >{{ pkg.code != "ENTREPRISE" ? $t("for") : "" }}
                    {{ pkg.price }}</span
                  >
                  <!-- <span
                    :class="{ 'text-white': pkg.popular }"
                    class="text-xs text-gray-500 ml-1"
                    >/{{ pkg.period }}</span
                  > -->
                  <!-- Student discount strikethrough (hidden with student option)
                  <span
                    v-if="
                      isStudent &&
                      pkg.code !== 'FREE' &&
                      pkg.code !== 'ENTREPRISE'
                    "
                    :class="{ 'text-white': pkg.popular }"
                    class="text-base text-gray-700 ml-1 line-through"
                    >${{ getStandartProductPrice(pkg.code) }}</span
                  >
                  -->
                </div>
                <p
                  :class="{ 'text-white': pkg.popular }"
                  class="text-xs text-gray-600 font-bold pb-2 h-10"
                >
                  {{ pkg.description }}
                </p>
                <!--  <p
                  :class="{ 'text-white opacity-70': pkg.popular }"
                  class="text-xs text-gray-500 font-normal"
                >
                  {{ pkg.description }}
                </p> -->
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(feature, index) in features"
            :key="index"
            :class="`${
              index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
            } transition-colors duration-300 hover:bg-gray-100`"
          >
            <td class="p-2 text-xs font-medium text-gray-700 w-96">
              {{ feature.name }}
            </td>
            <td v-for="(pkg, pkgIndex) in packages" :key="pkgIndex" class="p-2">
              <div
                v-if="feature.packages.includes(pkgIndex)"
                class="flex items-center space-x-1"
              >
                <svg
                  class="flex-shrink-0 w-5 h-5 text-green-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                  ></path>
                </svg>
                <span class="text-sm text-gray-600">
                  {{ feature.amounts ? feature.amounts[pkgIndex - 1] : "" }}
                </span>
              </div>
              <span v-else class="text-gray-300">-</span>
            </td>
          </tr>
          <tr>
            <td class="p-4"></td>
            <td v-for="(pkg, index) in packages" :key="index" class="p-4">
              <div
                v-if="
                  pkg.code === 'FREE' &&
                  authStore.token &&
                  userStore.subscriptionType !== 'FREE'
                "
                class="w-full min-h-[38px]"
              />
              <button
                v-else
                @click="handleClickOffer(pkg.code)"
                :class="`w-full py-2 px-2 rounded-lg font-semibold transition-all duration-300 text-nowrap ${
                  pkg.code === userStore.subscriptionType
                    ? 'bg-green-100 text-green-700 shadow-md border-[2px] border-green-700'
                    : 'bg-white border-[1px] border-slate-700 text-slate-900'
                }`"
              >
                {{
                  pkg.code === userStore.subscriptionType
                    ? t("active")
                    : index === 4
                    ? t("contact-us")
                    : t("get-started")
                }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Pay-as-you-go / deposit credit panel hidden (see commented block in git history)
    <div v-if="!isMonthlyTab" class="bg-white rounded-2xl ...">...</div>
    -->
    <div
      v-if="paymentsChoicePopup"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div class="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md">
        <h2 class="text-xl font-bold text-center mb-4 text-slate-900">
          {{ $t("choose-payment-method") }}
        </h2>

        <div class="space-y-3">
          <label
            class="flex items-center justify-between w-full p-3 h-14 border border-slate-300 rounded-lg cursor-pointer"
            :class="{ 'ring-2 ring-blue-500': selectedMethod === 'paypal' }"
          >
            <div class="flex items-center gap-3">
              <input
                type="radio"
                v-model="selectedMethod"
                value="paypal"
                class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
              />
              <i class="pi pi-credit-card text-blue-600 text-xl"></i>
              <span class="text-slate-900">{{ $t("pay-with-paypal") }}</span>
            </div>
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png"
              alt="PayPal"
              class="h-4"
            />
          </label>
          <!-- Wallet / account balance payment hidden: PayPal (or card) only from this modal
          <label
            class="flex items-center justify-between w-full p-3 h-14 border border-slate-300 rounded-lg"
            :class="{
              'opacity-60 cursor-not-allowed': insufficientFunds,
              'cursor-pointer': !insufficientFunds,
              'ring-2 ring-green-500':
                selectedMethod === 'balance' && !insufficientFunds,
            }"
          >
            <div class="flex items-center gap-3">
              <input
                type="radio"
                v-model="selectedMethod"
                value="balance"
                :disabled="insufficientFunds"
                class="h-4 w-4 text-green-600 border-gray-300 focus:ring-green-500"
              />
              <i class="pi pi-wallet text-green-600 text-xl"></i>
              <div>
                <span class="text-slate-900">{{
                  $t("pay-with-account-balance")
                }}</span>
                <div class="text-sm text-gray-500">
                  {{ $t("current-balance-0") }} ${{
                    userStore.userDeposit.toFixed(2)
                  }}
                </div>
              </div>
            </div>
          </label>
          -->
        </div>
        <div class="flex flex-col gap-2 mt-4 sm:flex-row sm:justify-end">
          <button
            @click="togglePaymentChoice"
            class="w-full sm:w-auto bg-white text-slate-900 border border-slate-400 h-10 px-4 rounded-lg font-medium"
          >
            {{ $t("cancel") }}
          </button>
          <button
            @click="handleContinue"
            class="w-full sm:w-auto bg-subDark text-white h-10 px-4 rounded-lg font-medium"
          >
            {{ $t("continue") }}
          </button>
        </div>
      </div>
    </div>
    <!-- Student offer: verification how-to modal (commented) -->
    <!--
    <div
      v-if="showStudentVerification"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div
        class="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[70%] lg:w-[50%] xl:w-[35%] mx-auto relative"
      >
        <i
          @click="showStudentVerification = false"
          :class="{ 'left-0': locale === 'ar', 'right-0': locale !== 'ar' }"
          class="pi pi-times text-[#061B44] cursor-pointer text-lg absolute px-4"
        ></i>
        <div
          :class="{
            'space-x-reverse': locale === 'ar',
          }"
          class="flex flex-row text-blue-600 font-medium text-xl items-center space-x-1 mb-4"
        >
          <i class="pi pi-envelope cursor-pointer text-xl text-center"></i>
          <p>{{ $t("how-to-submit-your-verification") }}</p>
        </div>
        <div class="flex flex-col space-y-2 text-sm text-gray-700 mb-6">
          <p>
            1. {{ $t("send-an-email-to") }}
            <span class="text-blue-600 font-medium"
              >support@subtitles.tech</span
            >
          </p>
          <p>2. {{ $t("include-your-full-name-and-the") }}</p>
          <p>3. {{ $t("attach-a-valid-school-issued-student-id") }}</p>
          <p>4. {{ $t("wait-2-3-business-days-for") }}</p>
        </div>
        <p class="text-sm text-orange-700 text-center">
          {{ $t("questions-about-student-verification-contact-us-at") }}
          <span class="text-blue-600 font-medium">support@subtitles.tech</span>
        </p>
      </div>
    </div>
    -->
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import CalculatorComponent from "../components/calculator_component.vue";
import {
  API_BASE_URL,
  CREATECHECKOUT,
  CREATECHECKOUTPAYPAL,
  BUYWITHBALANCE,
  CREATESUBSPAYPAL,
} from "../utils/appConst";
import { useAuthStore } from "../store/auth";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useUserProfile } from "../store/userProfile";
import { useUserActivities } from "../store/userActivities";
import { onMounted } from "vue";

const { t, locale } = useI18n();
const router = useRouter();
const authStore = useAuthStore();
const userStore = useUserProfile();
const activitesStore = useUserActivities();
const createCheckout = `${API_BASE_URL}${CREATECHECKOUT}`;
const createCheckoutPpl = `${API_BASE_URL}${CREATECHECKOUTPAYPAL}`;
const createSubscriptionPpl = `${API_BASE_URL}${CREATESUBSPAYPAL}`;
const buyWithBalancePpl = `${API_BASE_URL}${BUYWITHBALANCE}`;
const showPopup = ref<boolean>(false);
const isBannedArea = ref<boolean>(false);
const paymentsChoicePopup = ref<boolean>(false);
const payasyougoPopup = ref<boolean>(false);
const selectedDepositValue = ref<number>(5);
const isStudent = ref<boolean>(false);
const isMonthlyTab = ref<boolean>(true);
const showStudentVerification = ref<boolean>(false);
const selectedMethod = ref("paypal");
const bannedCountries: string[] = [];
const isCreatingDepositCheckout = ref<boolean>(false);
const insufficientFunds = computed(
  () =>
    userStore.userDeposit <
    authStore.products.find(
      (e) =>
        e.subscriptionType === selectedOffer.value &&
        !e.stripe &&
        e.isStudent === isStudent.value
    )?.price!
);
onMounted(() => {
  checkBannedArea();
});

const showCalculator = computed(() => activitesStore.showCalculator);

const togglePaymentTypeTab = (isMonthly: boolean) => {
  if (isMonthlyTab.value === isMonthly) return;
  isMonthlyTab.value = isMonthly;
};

const handleContinue = () => {
  switch (selectedMethod.value) {
    case "paypal":
      createCheckoutPaypal();
      break;
    case "balance":
      purchasePackUsingBalance();
      break;
    default:
      break;
  }
  togglePaymentChoice();
};

const depositItemsNames = computed(() => [
  { name: t("mini-trial") },
  { name: t("try-it-out") },
  { name: t("most-popular") },
  { name: t("regular-user") },
  { name: t("best-value") },
]);

const depositItemsList = computed(() => {
  const filteredProducts = authStore.products
    .filter((e) => e.subscriptionType === "CONSUMEASYOUPAY" && !e.stripe)
    .sort((a, b) => a.price - b.price);

  return filteredProducts.map((product, index) => ({
    ...product,
    name: depositItemsNames.value[index]?.name || "",
  }));
});

const selectedOffer = ref<string>("");

const togglePaymentChoice = () => {
  paymentsChoicePopup.value = !paymentsChoicePopup.value;
};

const togglePayasyougoChoice = () => {
  payasyougoPopup.value = !payasyougoPopup.value;
};

const checkBannedArea = async () => {
  try {
    const res = await fetch("https://www.cloudflare.com/cdn-cgi/trace");
    const text = await res.text();
    const match = text.match(/loc=(\w+)/);
    const countryCode = match ? match[1] : "US";
    isBannedArea.value = bannedCountries.includes(countryCode);
  } catch (error) {
    console.error("Network error:", error);
  }
};

const createCheckoutSession = async () => {
  if (!authStore.token) {
    router.push("/signing");
    return;
  }
  try {
    const checkoutPromise = new Promise<void>(async (resolve, reject) => {
      const response = await fetch(createCheckout, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        body: JSON.stringify({
          packageId: authStore.products.find(
            (e) =>
              e.subscriptionType === selectedOffer.value &&
              e.stripe &&
              e.isStudent === isStudent.value
          )?.productId,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        if (
          result.error === "Authorization header missing" ||
          result.error === "Invalid token"
        ) {
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/");
          reject(t("your-session-has-expired-please-log-in-again-to-continue"));
          return;
        } else {
          reject(t("server-error-please-try-again-later"));
          return;
        }
      }

      if (result.url) {
        window.location.href = result.url;
        return resolve();
      }
    });

    await toast.promise(
      checkoutPromise,
      {
        pending: t("please-wait"),
        success: t("redirecting-to-checkout"),
      },
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: true,
        closeOnClick: true,
        theme: "light",
      }
    );
  } catch (error: any) {
    console.error("Checkout session creation failed:", error);
    toast.error(error, {
      autoClose: 2500,
      position: toast.POSITION.TOP_CENTER,
      theme: "light",
    });
  }
};

const setSelectedDepositValue = async (value: number) => {
  selectedDepositValue.value = value;
};

const createDepositCheckoutPaypal = async () => {
  if (!authStore.token) {
    router.push("/signing");
    return;
  }
  if (isBannedArea.value) {
    return;
  }
  if (isCreatingDepositCheckout.value) {
    return; // Prevent double-clicks
  }
  isCreatingDepositCheckout.value = true;
  try {
    const checkoutPromise = new Promise<void>(async (resolve, reject) => {
      const response = await fetch(createCheckoutPpl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        body: JSON.stringify({
          packageId: authStore.products.find(
            (e) =>
              e.subscriptionType === "CONSUMEASYOUPAY" &&
              !e.stripe &&
              e.price === selectedDepositValue.value
          )?.productId,
        }),
      });
      const result = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          reject(t("your-session-has-expired-please-log-in-again-to-continue"));
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        } else if (response.status === 403) {
          reject(t("student-verification-required-please"));
          return;
        } else if (response.status === 404) {
          reject(t("product-not-found-item-unavailable"));
          return;
        } else {
          reject(t("server-error-please-try-again-later"));
          return;
        }
      }
      console.log("response ---------->", result);

      if (result.url) {
        window.location.href = result.url;
        return resolve();
      }
    });

    await toast.promise(
      checkoutPromise,
      {
        pending: t("please-wait"),
        success: t("redirecting-to-checkout"),
      },
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: true,
        closeOnClick: true,
        theme: "light",
      }
    );
  } catch (error: any) {
    console.error("Checkout session creation failed:", error);
    toast.error(error, {
      autoClose: 3500,
      position: toast.POSITION.TOP_CENTER,
      theme: "light",
    });
  } finally {
    isCreatingDepositCheckout.value = false;
  }
};

const createCheckoutPaypal = async () => {
  if (!authStore.token) {
    router.push("/signing");
    return;
  }
  if (isBannedArea.value) {
    return;
  }
  try {
    if (isStudent.value) {
      if (!userStore.isStudent) {
        toast.error(t("this-product-is-exclusively-available"), {
          autoClose: 3500,
          position: toast.POSITION.TOP_CENTER,
          theme: "light",
        });
        return;
      }
    }

    const checkoutPromise = new Promise<void>(async (resolve, reject) => {
      const response = await fetch(createSubscriptionPpl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        body: JSON.stringify({
          packageId: authStore.products.find(
            (e) =>
              e.subscriptionType === selectedOffer.value &&
              !e.stripe &&
              e.isStudent === isStudent.value
          )?.productId,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        if (response.status === 401) {
          reject(t("your-session-has-expired-please-log-in-again-to-continue"));
          await new Promise((resolve) => setTimeout(resolve, 2500));
          authStore.logout();
          router.push("/signing");
          return;
        } else if (response.status === 403) {
          reject(t("student-verification-required-please"));
          return;
        } else if (response.status === 404) {
          reject(t("product-not-found-item-unavailable"));
          return;
        } else {
          reject(t("server-error-please-try-again-later"));
          return;
        }
      }
      console.log("response ---------->", result);

      if (result.url) {
        window.location.href = result.url;
        return resolve();
      }
    });

    await toast.promise(
      checkoutPromise,
      {
        pending: t("please-wait"),
        success: t("redirecting-to-checkout"),
      },
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: true,
        closeOnClick: true,
        theme: "light",
      }
    );
  } catch (error: any) {
    console.error("Checkout session creation failed:", error);
    toast.error(error, {
      autoClose: 3500,
      position: toast.POSITION.TOP_CENTER,
      theme: "light",
    });
  }
};

const purchasePackUsingBalance = async () => {
  if (!authStore.token) {
    router.push("/signing");
    return;
  }
  if (isBannedArea.value) {
    return;
  }
  try {
    if (isStudent.value) {
      if (!userStore.isStudent) {
        toast.error(t("this-product-is-exclusively-available"), {
          autoClose: 3500,
          position: toast.POSITION.TOP_CENTER,
          theme: "light",
        });
        return;
      }
    }

    const isEnough =
      userStore.userDeposit >=
      authStore.products.find(
        (e) =>
          e.subscriptionType === selectedOffer.value &&
          !e.stripe &&
          e.isStudent === isStudent.value
      )?.price!;

    if (!isEnough) {
      toast.error(
        t(
          "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
        ),
        {
          autoClose: 3500,
          position: toast.POSITION.TOP_CENTER,
          theme: "light",
        }
      );
      return;
    }

    const checkoutPromise = new Promise<void>(async (resolve, reject) => {
      const response = await fetch(buyWithBalancePpl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authStore.token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        body: JSON.stringify({
          productId: authStore.products.find(
            (e) =>
              e.subscriptionType === selectedOffer.value &&
              !e.stripe &&
              e.isStudent === isStudent.value
          )?.productId,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        switch (response.status) {
          case 401:
            reject(
              t("your-session-has-expired-please-log-in-again-to-continue")
            );
            await new Promise((resolve) => setTimeout(resolve, 2500));
            authStore.logout();
            router.push("/signing");
            break;
          case 400:
            switch (true) {
              case result.error.includes("Insufficient balance"):
                reject(
                  t(
                    "insufficient-balance-please-recharge-your-account-to-complete-this-operation"
                  )
                );
                break;
              case result.error.includes("Invalid student status"):
                reject(t("student-verification-required-please"));
                break;
            }
            break;
          case 404:
            reject(t("product-not-found-item-unavailable"));
            break;
          default:
            reject(t("were-fixing-a-technical-issue-so-please-try"));
        }
        return;
      }

      userStore.userDeposit = parseFloat(result.newBalance);
      userStore.subscriptionType = result.subscriptionType;
      resolve();
    });

    await toast.promise(
      checkoutPromise,
      {
        pending: t("please-wait"),
        success: t("thank-you-for-your-order-it"),
      },
      {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3500,
        closeOnClick: true,
        theme: "light",
      }
    );
  } catch (error: any) {
    console.error("Purchase failed:", error);
    toast.error(error, {
      autoClose: 3500,
      position: toast.POSITION.TOP_CENTER,
      theme: "light",
    });
  }
};

const navigate = (path: string) => {
  router.push(`/${path}`);
};

const isExpired = (): boolean => {
  const currentTimestamp = new Date(new Date().toISOString());
  const subscriptionEndDate = new Date(userStore.subscriptionEndDate);
  if (currentTimestamp > subscriptionEndDate) {
    return true;
  } else {
    return false;
  }
};

const handleClickOffer = async (offerName: string) => {
  selectedOffer.value = offerName;
  if (isBannedArea.value) {
    toast(t("this-service-is-currently-un"), {
      autoClose: 2500,
      type: "warning",
      theme: "light",
    });
    return;
  }
  if (offerName === "ENTREPRISE") {
    if (router.currentRoute.value.name === "Pricing") {
      router.push({ hash: "#contact" });
    } else {
      router.push({ name: "Pricing", hash: "#contact" });
    }
  } else if ("FREE" === offerName) {
    if (!authStore.token) {
      router.push("/signing-up");
    }
    return;
  } else if (!authStore.token) {
    navigate("signing");
  } else {
    //if (!userStore.subscriptionType || userStore.subscriptionType === "FREE") {
    togglePaymentChoice();
    //await createCheckoutSession(offerName);
    //} else {
    //  toggleModal();
    //}
  }
};

const toggleModal = () => {
  showPopup.value = !showPopup.value;
  document.body.classList.toggle("modal-open", showPopup.value);
};

function getProductPrice(pack: string): number {
  return (
    authStore.products.find(
      (e) => e.subscriptionType === pack && e.isStudent === isStudent.value
    )?.price || 0
  );
}

function getStandartProductPrice(pack: string): number {
  return (
    authStore.products.find(
      (e) => e.subscriptionType === pack && e.isStudent === false
    )?.price || 0
  );
}

const packages = computed(() => [
  {
    name: t("free"),
    code: "FREE",
    price: "0$",
    period: t("month"),
    subtitle: t("start-your-journey-with-no-cost"),
    description: t("perfect-for-basic-needs"),
  },
  {
    name: t("starter"),
    code: "STARTER",
    price: `${getProductPrice("STARTER")}$`,
    period: t("month"),
    subtitle: t("growing-projects-smart-savings"),
    description: t("for-regular-individual-users-or-small-projects"),
  },
  {
    name: t("pro"),
    code: "PRO",
    price: `${getProductPrice("PRO")}$`,
    period: t("month"),
    subtitle: t("power-user-perfection"),
    description: t("for-serious-creators-and-professionals"),
    popular: true,
  },
  {
    name: t("premium"),
    code: "PREMIUM",
    price: `${getProductPrice("PREMIUM")}$`,
    period: t("month"),
    subtitle: t("enterprise-ready-performance"),
    description: t("for-high-volume-content"),
  },
  {
    name: t("enterprise"),
    code: "ENTREPRISE",
    price: t("custom"),
    period: "",
    description: t("custom-solutions-for-larger-organizations"),
  },
]);
const features = computed(() => [
  {
    name: t("unlimited-youtube-transcription-for-videos-with-cc"),
    packages: [0, 1, 2, 3, 4],
  },
  {
    name: t("free-ai-content-summarization"),
    packages: [1, 2, 3, 4],
  },
  {
    name: t("audio-transcription"),
    packages: [1, 2, 3, 4],
    amounts: [t("30-min"), t("90-min"), t("180-min"), t("custom")],
  },
  {
    name: t("translation-between-140-languages"),
    packages: [1, 2, 3, 4],
    amounts: [t("30k-chars"), t("100k-chars"), t("200k-chars"), t("custom")],
  },
  {
    name: t("text-to-realistic-voice-over-using-ai"),
    packages: [1, 2, 3, 4],
    amounts: [t("30k-chars"), t("100k-chars"), t("200k-chars"), t("custom")],
  },
  { name: t("pay-as-you-go-pricing-model"), packages: [4] },
  { name: t("flexible-seat-options-based-on-your-needs"), packages: [4] },
  { name: t("custom-consumption-estimates-based-on-usage"), packages: [4] },
  { name: t("dedicated-account-management"), packages: [4] },
]);

function getFirstCapitalizedName(name: string): string {
  return name
    .replace(/-/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

interface FAQ {
  question: string;
  answer: string;
}

export interface Product {
  productId: string;
  price: number;
  subscriptionType: string;
  stripe: boolean;
  isStudent: boolean;
}
</script>

<style scoped>
body.modal-open {
  overflow: hidden;
}
</style>
